import { createClient } from "@supabase/supabase-js";
import { getRedirectUrl } from "./auth";

// Supabase configuration from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables. Please check your .env file.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Auth helpers
export const signInWithGoogle = () => {
  return supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: getRedirectUrl("/generate"),
    },
  });
};

export const signInWithGitHub = () => {
  return supabase.auth.signInWithOAuth({
    provider: "github",
    options: {
      redirectTo: getRedirectUrl("/generate"),
    },
  });
};

export const signOut = () => {
  return supabase.auth.signOut();
};

export const getCurrentUser = () => {
  return supabase.auth.getUser();
};

export const getSession = () => {
  return supabase.auth.getSession();
};
